import { render } from "./DesktopTabs.vue?vue&type=template&id=db557cec&scoped=true&ts=true"
import script from "./DesktopTabs.vue?vue&type=script&lang=ts"
export * from "./DesktopTabs.vue?vue&type=script&lang=ts"

import "./DesktopTabs.vue?vue&type=style&index=0&id=db557cec&lang=scss&scoped=true"

import exportComponent from "/home/node/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db557cec"]])

export default __exports__